exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".c-expander_props-childs{overflow:hidden;max-height:0;max-width:83vw;transition:max-height .5s;-ms-transition:max-height .5s;-o-transition:max-height .5s;-webkit-transition:max-height .5s;margin-left:-238px}.c-expander_props-childs.is-open{overflow:visible;max-height:1000px}.c-expander_props-childs>*{margin-top:18px}.c-expander_button{min-height:50px;display:flex;align-items:center;cursor:pointer;color:#b52372;user-select:none}.c-expander_button path{fill:#b52372;margin-right:10px}.c-expander_button>div{margin-left:10px}", ""]);

// exports
